import React from 'react'
import FoundationCheckbox from '@envato/foundation-checkbox'
import { Link } from 'react-router-dom'

import styles from './index.module.css'

class Checkbox extends React.Component {
  render() {
    const { value, count, color, onSelectionChange, checked, link } = this.props
    const checkboxColor = styles[color]

    return (
      <div className={styles.optionWrapper}>
        <Link to={link} className={styles.link}>
          <FoundationCheckbox
            color={checkboxColor}
            checked={checked}
            onChange={onSelectionChange.bind(null, value)}
          >
            {this.props.children}
          </FoundationCheckbox>
        </Link>
        <span className={styles.count}>{count}</span>
      </div>
    )
  }
}

export default Checkbox
